import { Type } from '@sinclair/typebox';
import { SafeNonNegativeInteger } from './cursor.js';
import { ProtocolVersionSchema } from './version.js';
const NonEmptyString = Type.String({ minLength: 1 });
const NonNegativeInteger = Type.Integer({ minimum: 0 });
const CanonicalBase64 = Type.String({
    minLength: 4,
    pattern: '^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$',
});
const Strict = (properties) => Type.Object(properties, { additionalProperties: false });
export const ResourceStatus = Type.Union([
    Type.Literal('pending'),
    Type.Literal('available'),
    Type.Literal('failed'),
    Type.Literal('unavailable'),
]);
export const ResourceBinding = Strict({
    locator: NonEmptyString,
    resourceId: NonEmptyString,
    status: ResourceStatus,
});
export const ResourceRequest = Strict({
    protocolVersion: ProtocolVersionSchema,
    type: Type.Literal('resource_request'),
    payload: Strict({ requestId: NonEmptyString, agentId: NonEmptyString, resourceId: NonEmptyString }),
});
export const ResourceState = Type.Union([
    Strict({ status: Type.Literal('pending'), retryAfterMs: Type.Integer({ minimum: 1 }) }),
    Strict({
        status: Type.Literal('available'),
        mediaType: NonEmptyString,
        byteLength: NonNegativeInteger,
        sha256: NonEmptyString,
    }),
    Strict({ status: Type.Literal('failed'), message: NonEmptyString, retryable: Type.Boolean() }),
    Strict({ status: Type.Literal('unavailable'), reason: NonEmptyString }),
]);
export const ResourceResponseState = Type.Union([
    Strict({ status: Type.Literal('pending'), retryAfterMs: Type.Integer({ minimum: 1 }) }),
    Strict({
        status: Type.Literal('available'),
        mediaType: NonEmptyString,
        byteLength: NonNegativeInteger,
        sha256: NonEmptyString,
        contentBase64: CanonicalBase64,
    }),
    Strict({ status: Type.Literal('failed'), message: NonEmptyString, retryable: Type.Boolean() }),
    Strict({ status: Type.Literal('unavailable'), reason: NonEmptyString }),
]);
export const ResourceResponse = Strict({
    protocolVersion: ProtocolVersionSchema,
    type: Type.Literal('resource_response'),
    payload: Strict({
        requestId: NonEmptyString,
        agentId: NonEmptyString,
        resourceId: NonEmptyString,
        state: ResourceResponseState,
    }),
});
export const ResourceUpdate = Strict({
    protocolVersion: ProtocolVersionSchema,
    type: Type.Literal('resource_update'),
    payload: Strict({
        agentId: NonEmptyString,
        resourceId: NonEmptyString,
        state: ResourceState,
    }),
});
export const TimelineResourceBindingReplacement = Strict({
    protocolVersion: ProtocolVersionSchema,
    type: Type.Literal('timeline_resource_binding_replaced'),
    payload: Strict({
        agentId: NonEmptyString,
        epoch: NonEmptyString,
        seq: SafeNonNegativeInteger,
        previous: ResourceBinding,
        replacement: ResourceBinding,
    }),
});
//# sourceMappingURL=resources.js.map